import SportEvent from './SportEvent';

export default SportEvent;



// WEBPACK FOOTER //
// ./src/components/SportEvent/index.tsx